import { createApp } from "vue";
import {
    Divider,
    Popup,
    Overlay,
    Loading,
    Dialog,
    Tabbar,
    TabbarItem,
    Form,
    Skeleton,
    Lazyload,
    Empty,
    Collapse,
    CollapseItem,
    Uploader,
    Switch,
    NavBar,
    Image as VanImage,
    Col,
    Row,
    Tag,
    Badge,
    Grid,
    GridItem,
    Field,
    NoticeBar,
    CellGroup,
    Cell,
    SwipeCell,
    Icon,
    Checkbox,
    CheckboxGroup,
    Button,
    Swipe,
    SwipeItem,
    PullRefresh,
    List,
    Tab,
    Tabs,
    ImagePreview,
    Toast,
} from "vant";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "lib-flexible/flexible";
import "vant/lib/index.css"; // 全局引入样式
import "./assets/main.css";
import "./assets/nouislider.min.css";

const app = createApp(App); // 创建实例
app.config.errorHandler = (err, vm, info) => {
    // handle error
    // `info` is a Vue-specific error info, e.g. which lifecycle hook
    // the error was found in
    if (Object.keys(err).length > 0) {
        console.log(JSON.stringify(err));
        console.log(JSON.stringify(info));
    }
}

app
    .use(Divider)
    .use(Popup)
    .use(Overlay)
    .use(Loading)
    .use(Dialog)
    .use(Toast)
    .use(Form)
    .use(Skeleton)
    .use(Lazyload)
    .use(Empty)
    .use(Collapse)
    .use(CollapseItem)
    .use(Uploader)
    .use(Switch)
    .use(NavBar)
    .use(VanImage)
    .use(Col)
    .use(Row)
    .use(Tag)
    .use(Badge)
    .use(Grid)
    .use(GridItem)
    .use(Field)
    .use(NoticeBar)
    .use(CellGroup)
    .use(Cell)
    .use(SwipeCell)
    .use(Icon)
    .use(Button)
    .use(Swipe)
    .use(SwipeItem)
    .use(PullRefresh)
    .use(List)
    .use(Tab)
    .use(Tabs)
    .use(Tabbar)
    .use(TabbarItem)
    .use(ImagePreview)
    .use(Checkbox)
    .use(CheckboxGroup)

app.use(router);
app.use(store);

app.mount("#app");